<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import $ from "jquery";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import DatePicker from "vue3-persian-datetime-picker";
import persianDate from 'persian-date';
import {Device} from "@capacitor/device";

export default {
  name: "FinalPayment",
  components: {DatePicker, LoadingPic, LoadingPage},

  setup() {

    let loading = ref(false)

    let loading_pic = ref(false)
    let show_pic = ref(null)

    let dialog = ref({
      action: false,
      type: 'one',
    })

    let order = ref({
      wallet: 0,
      count: 0,
      price: 0,
      price_off: 0,
      profit: 0,
    })
    let cheque = ref([])

    let accept_data = ref({
      action: 'pay',
      oid: useRoute().params.oid,
      sid: useRoute().params.sid,
      pay_type: null,
    })
    let pay_cheque = ref({
      month: null,
      sayad: '',
      bank: '',
      date: null,
      pic: null,
    })
    let check_date_cheque = null


    function info_order() {

      loading.value = true
      FreeWorld.Heisenberg({oid: accept_data.value.oid}, 'order', true).then((res) => {

        loading.value = false
        order.value = res.data
        order.value.cheque.forEach((item, index) => {
          if (index === 0) cheque.value.push({name: 'یک ماهه', price: item , month: 1})
          if (index === 1) cheque.value.push({name: 'دو ماهه', price: item , month: 2})
          if (index === 2) cheque.value.push({name: 'سه ماهه', price: item , month: 3})
          if (index === 3) cheque.value.push({name: 'چهار ماهه', price: item , month: 4})
          if (index === 4) cheque.value.push({name: 'پنج ماهه', price: item , month: 5})
          if (index === 5) cheque.value.push({name: 'شش ماهه', price: item , month: 6})
        })

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, info_order)
      })

    }
    info_order()

    function open_dialogs(action , type) {
      let today, futureDate
      switch (action) {

        case 'show':
          if (type === 'two' && pay_cheque.value.month === null){Swals.Fault('لطفا مدت زمان چک خود را انتخاب کنید!');return false}
          $("#" + type).removeClass('animate__fadeOut').addClass('animate__fadeIn')

          if (type === 'two' && pay_cheque.value.month !== null){
            today = new persianDate();
            futureDate = today.add('month', pay_cheque.value.month);
            check_date_cheque = futureDate.toLocale('en').format('YYYY/MM/DD');
            pay_cheque.value.date = check_date_cheque
          }

          dialog.value.type = type
          dialog.value.action = true
              break;

        case 'close':
          $("#" + dialog.value.type).removeClass('animate__fadeIn').addClass('animate__fadeOut')
          setTimeout(() => {
            dialog.value.action = false
            pay_cheque.value = {
              month: null,
              sayad: '',
              bank: '',
              date: null,
              pic: null,
            }
            check_date_cheque = null
          }, 700)
              break;

      }

    }

    function upload_pic(e) {

      const file = e.target.files[0];
      if (file !== undefined) {

        loading_pic.value = true
        FreeWorld.GoodMan(file).then((res)=>{

                loading_pic.value = false
              if (res.data.status === 'ok') {
                show_pic.value = URL.createObjectURL(file);
                pay_cheque.value.pic = res.data.name
              }else {
                Swals.Fault('لطفا از فرمت عکس مورد نظر اطمینان حاصل فرمایید!')
              }


        }).catch((res) => {
          loading_pic.value = false
          Swals.Catch(res , ()=>{upload_pic(e)})
        })
      }


    }

    function accept_order() {
      let today , today_date
      if (accept_data.value.pay_type === null) {
        Swals.Fault('لطفا یکی از روش های پرداخت را انتخاب کنبد!');
        return false
      }

      let data

      let device = ref()

      let sent = false

      switch (accept_data.value.pay_type) {

        case 'wallet':
            if (order.value.wallet < order.value.price_off){Swals.Fault('متاسفانه موجودی کیف پول شما کافی نمی باشد!');return false}
            data = accept_data.value
            sent = true
          break;

        case 'bank':
          data = accept_data.value


           Device.getInfo().then(info => {
            device.value = info.platform
          });

          window.location.href = 'https://market-app.ir/bank?action=send&mode=order&oid=' + accept_data.value.oid +'&uid=0&device=' + device.value

          sent = false
          break;

        case 'cheque':
          if (!dialog.value.action){
          open_dialogs('show' , 'one')
          }else {
            if (pay_cheque.value.sayad.length === 0){Swals.Fault('لطفا شماره صیادی چک را وارد کنید!');return false}
            if (pay_cheque.value.bank.trim().length === 0){Swals.Fault('لطفا نام بانک را وارد کنید!');return false}
            if (pay_cheque.value.pic === null){Swals.Fault('لطفا تصویر چک را وارد کنید!');return false}

             today = new Date
             today_date = new persianDate(today).toLocale('en').format('YYYY/MM/DD')

            if (pay_cheque.value.date > check_date_cheque || pay_cheque.value.date < today_date){Swals.Fault('لطفا تاریخ چک را در بازه زمانی انتخاب شده وارد کنید!');return false}

            data = Object.assign({} , pay_cheque.value , accept_data.value)
            sent = true
          }
          break;

      }

      if (sent){

        loading.value = true
        FreeWorld.Heisenberg(data , 'orders_act' , true).then((res)=>{

          loading.value = false
          if (accept_data.value.pay_type === 'wallet' && res.data.status === 'ok'){
            Swals.Done('مبلغ سفارش شما با موفقیت از کیف پولتان کسر شد' , 'MyOrders')
          }else if(accept_data.value.pay_type === 'cheque' && res.data.status === 'ok') {
            Swals.Done('اطلاعات پرداخت شما ثبت شد و تیم پشتیبانی در اسرع وقت با شما تماس برقرار میکنند' , 'MyOrders')
          }else if(accept_data.value.pay_type === 'bank' && res.data.status === 'error bank'){
            Swals.Fault('متاسفانه در حال حاضر درگاه پرداخت در دسترس نمی باشد!')
          }else{
            Swals.Fault('متاسفانه سفارش شما پرداخت نشد!')
          }

          open_dialogs('close')

        }).catch((res)=>{
          loading.value = false
          Swals.Catch(res , accept_order)
        })

      }


    }

    return {

      loading,
      loading_pic,
      cheque,
      order,
      accept_data,
      pay_cheque,
      accept_order,
      dialog,
      open_dialogs,
      upload_pic,
      show_pic,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog.action" @click="open_dialogs('close')" class="bg_dialog"></div>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <router-link :to="{name:'HomePage'}" class="text-decoration-none d-flex align-items-center">
        <p class="font-4 font-color">انصراف</p>
        <img src="../assets/img/closing_color.svg" alt="" class="svg-arrow">
      </router-link>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مشاهده سبد خرید</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">


      <div class="bg-white rounded-4 shadow-custom mb-5">

        <div class="d-flex align-items-center rounded-4 justify-content-between mb-3 overflow-hidden">

          <div class="d-flex w-30 p-2 flex-column align-items-center">
            <img class="icons mb-2" src="../assets/img/icon_buy_box_NA.svg" alt="">
            <p class="font-4 font-color_light">سبد خرید</p>
          </div>

          <div class="d-flex w-30 p-2 flex-column align-items-center">
            <img class="icons mb-2" src="../assets/img/gps_light.svg" alt="">
            <p class="font-5 font-color_light">اطلاعات ارسال</p>
          </div>

          <div class="d-flex w-30 p-2 flex-column align-items-center shadow_select rounded-top-4">
            <img class="icons mb-2" src="../assets/img/credit-card-payment.svg" alt="">
            <p class="font-5 font-color">اطلاعات پرداخت</p>
          </div>

        </div>


        <div class="p-body">
          <p class="font-4 font-bold mb-2 font-color">انتخاب روش پرداخت</p>

          <div class="list_address">

            <div class="rounded-4 bg-color-blue-light p-2 py-3 mb-3 shadow-custom overflow-hidden">

              <div class="d-flex align-items-center">
                <input v-model="accept_data.pay_type" class="ml-2" id="bank" value="bank" name="payment" type="radio">
                <label for="bank" class="font-4">پرداخت از درگاه بانکی</label>
              </div>

              <div class="div_hr my-3"></div>

              <div class="d-flex align-items-center">
                <input v-model="accept_data.pay_type" class="ml-2" id="wallet" value="wallet" name="payment"
                       type="radio">
                <label for="wallet" class="font-4">پرداخت از کیف پول</label>
              </div>

              <div class="div_hr my-3"></div>

              <div v-if="cheque.length !== 0" class="animate__animated animate__fadeInRight">

                <div class="d-flex align-items-center">
                  <input v-model="accept_data.pay_type" class="ml-2" id="cheque" value="cheque" name="payment"
                         type="radio">
                  <label for="cheque" class="font-4">پرداخت با چک</label>
                </div>

                <div class="div_hr my-3"></div>

              </div>

              <div class="d-flex align-items-center justify-content-between">

                <div class="d-flex align-items-center">
                  <img style="height: 25px" class="icon_shadow" src="../assets/img/icon_wallet_color.svg" alt="">

                  <div class="d-flex align-items-center">
                    <span class="mx-1 font-5">موجودی کیف پول شما :</span>
                    <span class="font-color font-bold font-4 mx-1">{{ order.wallet.toLocaleString() }}</span>
                    <span class="font-color font-5">تومان</span>
                  </div>
                </div>

              </div>

              <div class="d-flex justify-content-center align-items-center mt-3">
                <router-link :to="{name:'WalletPage'}" class="text-decoration-none w-50">
                  <v-btn class="p-2 h-100 w-100 text-center bg-green rounded-3 font-5 text-white">افزایش موجودی کیف
                    پول
                  </v-btn>
                </router-link>
              </div>
            </div>

            <div class="bg-color-blue-light rounded-4 p-3 my-3">
              <p class="font-color font-3 font-bold text-center">جزئیات پرداخت</p>

              <div class="div_hr my-2"></div>
              <div class="d-flex align-items-center justify-content-between p-2">
                <p class="font-4">تعداد اقلام</p>
                <p class="font-4">{{ order.count }}</p>
              </div>

              <div class="div_hr my-2"></div>
              <div class="d-flex align-items-center justify-content-between p-2">
                <p class="font-4">جمع کل قبل از تخفیف</p>
                <p class="font-4 d-flex">
                  <span class="">{{ order.price.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr my-2"></div>
              <div class="d-flex align-items-center justify-content-between p-2">
                <p class="font-4">سود شما از این خرید</p>
                <p class="font-4 d-flex">
                  <span class="">{{ order.profit.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>

              <div class="div_hr my-2"></div>
              <div class="d-flex bg-white rounded-3 align-items-center justify-content-between px-2 py-3">
                <p class="font-4">مبلغ قابل پرداخت</p>
                <p class="font-4 font-bold font-color-green d-flex">
                  <span class="">{{ order.price_off.toLocaleString() }}</span>
                  <span class="mr-1">تومان</span>
                </p>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="d-flex justify-content-center mb-3">
        <v-btn @click="accept_order" class="bg-color h-100 rounded-4 p-3 font-4 shadow-custom text-white w-90">ثبت سفارش
          نهایی
        </v-btn>
      </div>

    </div>


    <!--    dialog one-->
    <div v-if="dialog.action && dialog.type === 'one'" id="one" class="animate__animated animate__fadeIn dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_record_card.svg" alt="">
          <p class="text-white font-4">تعیین مدت چک</p>
        </div>

        <div class="p-3">
          <p class="font-5 text-center mb-4">مدت زمان پرداخت سفارش را مشخص کنید</p>
          <p class="font-5 text-center mb-4">به ازای هر ماه 4 درصد به هزینه فاکتور اضافه میگردد</p>

          <label v-for="(item , index) in cheque" :key="index" :for="'time_cheque' + index" class="mb-3 d-flex justify-content-between align-items-center shadow-custom p-3 rounded-4">
            <div class="d-flex align-items-center">
              <input v-model="pay_cheque.month" class="ml-2" :value="item.month" :id="'time_cheque' + index" name="time_cheque" type="radio">

              <p class="font-4 font-bold font-color">{{ item.name }}</p>
            </div>

            <p class="d-flex font-4 font-color font-bold align-items-center">
              <span class="">{{ item.price.toLocaleString() }}</span>
              <span class="mr-1 font-5">تومان</span>
            </p>
          </label>

          <div class="d-flex justify-content-center align-items-center">
            <v-btn @click="open_dialogs('show' , 'two')" class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">تایید</v-btn>
          </div>

        </div>
      </div>
    </div>


    <!--dialog two-->
    <div v-if="dialog.action && dialog.type === 'two'" id="two" class="animate__animated animate__fadeIn dialog max_width p-body">
      <div class="bg-white rounded-4">

        <div style="height: 45px"
             class="bg-color d-flex justify-content-center align-items-center rounded-top-4 text-center position-relative">
          <img style="height: 10vh;left: 0" class="position-absolute bottom-0"
               src="../assets/img/icon_record_card.svg" alt="">
          <p class="text-white font-4">ثبت چک</p>
        </div>

        <div class="p-3">
          <p class="font-5 text-center mb-4">جهت پرداخت با چک، یک فقره چک با تاریخ حداکثر ماه انتخاب شده
            پس از تاریخ ثبت سفارش در وجه اپلیکیشن ... صادر کرده
            و شماره و تصویر چک را آپلود نمایید.
          </p>


          <p class="font-bold font-4 font-color mb-2">شماره صیادی</p>
          <input v-model="pay_cheque.sayad" class="p-3 text-center shadow-custom rounded-4 font-4 w-100 mb-4" type="text" placeholder="شماره چک">

          <p class="font-bold font-4 font-color mb-2">بانک صادر کننده</p>
          <input v-model="pay_cheque.bank" class="p-3 text-center shadow-custom rounded-4 font-4 w-100 mb-4" type="text" placeholder="نام بانک">

          <p class="font-bold font-4 font-color mb-2">تاریخ چک</p>
          <div class="shadow-custom bg-white font-4 rounded-4 border-0 w-100 py-3 mb-4 px-2 text-center">
            <date-picker class="text-center border-0" v-model="pay_cheque.date"></date-picker>
          </div>

          <p class="font-bold font-4 font-color mb-2">تصویر چک</p>
          <input @change="upload_pic" style="display: none" id="photo" type="file">
          <label style="height: 150px" class="w-100 shadow-custom rounded-4 mb-4 position-relative" for="photo">
            <LoadingPic v-if="loading_pic"></LoadingPic>
            <img v-if="pay_cheque.pic === null" class="w-100 h-100 rounded-4" src="../assets/img/add_photo.svg" alt="">
            <img v-else class="w-100 h-100 rounded-4" :src="show_pic" alt="">
          </label>


          <div class="d-flex justify-content-center align-items-center">
            <v-btn @click="accept_order" class="w-100 h-100 bg-color rounded-4 shadow-custom text-white p-3 font-4">ارسال</v-btn>
          </div>

        </div>
      </div>
    </div>

  </div>

</template>


<style scoped>

.icons {
  width: 30px;
  height: 30px;
}

.shadow_select {
  box-shadow: 0 -7px 15px -2px #707070;
}

.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

</style>